import { render } from "./adminView.vue?vue&type=template&id=7494ae12&scoped=true"
import script from "./adminView.vue?vue&type=script&lang=js"
export * from "./adminView.vue?vue&type=script&lang=js"

import "./adminView.vue?vue&type=style&index=0&id=7494ae12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7494ae12"]])

export default __exports__